import { useJSONFetcher, JSONFetcherOptions } from "@outplayed/json-fetcher";
import { useUGGApiVersions } from "../ugg-api-versions";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { getApiRoot } from "@ugg/shared/api/api-helpers";
import { cleanItems } from "@ugg/shared/api/data-parser/champions/items";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

import { Items } from "@ugg/shared/interfaces/champions/items.interface";

export function useItemsURL(championId: number, options: { queueType?: string; patch?: string }) {
  const { queueType, patch } = options;
  const { data: version } = useUGGApiVersions({ apiKey: "items", patch });
  const root = getApiRoot(patch);

  return [`${root}/table/items`, patch, queueType, championId, `${version}.json`].join("/");
}

export function useChampionItems(
  championId: number,
  options?: { params?: Record<string, any> } & JSONFetcherOptions<Items, ReturnType<typeof cleanItems>>,
) {
  const { params = {}, ssr = false, skip = false } = options || {};
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.ITEMS, params, true);

  const championItemsURL = useItemsURL(championId, validatedQueryParams);
  return useJSONFetcher<Items, ReturnType<typeof cleanItems>>(championItemsURL, {
    ssr,
    skip,
    onCompleted: (url, json) => cleanItems(json),
  });
}
